import { useSurveysQuery } from '../data-access';

export const useSurveysClosed = (partnerId: string) => {
	const {
		data: surveysClosedData,
		error: surveysClosedError,
		isLoading: isSurveysClosedLoading,
		refetch: refetchClosedSurveys
	} = useSurveysQuery({
		'details[]': ['surveyTranslations'],
		direction: 'desc',
		orderBy: 'closeAt',
		'partnerIds[]': [partnerId],
		'statuses[]': ['closed']
	});

	return { isSurveysClosedLoading, refetchClosedSurveys, surveysClosedData, surveysClosedError } as const;
};
